import state from './module-connect-invoice-state';
import mutations from './module-connect-invoice-mutations';
import actions from './module-connect-invoice-actions';
import getters from './module-connect-invoice-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
